import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteProductSet } from "../../../apis";
import { DeleteProductModalProps } from "./DeleteProductSetModal.types";

import styles from "./DeleteProductSetModal.module.scss";

const DeleteProductModal = ({
  isOpen,
  id,
  onClose,
  onDeleteSuccess
}: DeleteProductModalProps) => {
  const deleteProductSet = useDeleteProductSet({
    onSuccess: () => {
      onClose();
      onDeleteSuccess?.();
      toast.success(t("Product set has been deleted successfully"));
    }
  });

  if (!id) return null;

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={t("Delete product set")}
      isLoading={deleteProductSet.isLoading}
      okText="Delete"
      onOk={() => deleteProductSet.mutate(id)}
      onClose={onClose}
      contentClassName={styles.modal}
    >
      <p className={styles.modal_text}>
        {t("Are you sure you want to delete this product set?")}
      </p>
    </Modal>
  );
};

export default DeleteProductModal;
